<template>
  <el-table :data="list" class="table-shin-expand">
    <el-table-column label="物料名称" width="200px">
      <template scope="props">
        <p class="no-margin">{{props.row.ProductName}}</p>
        <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
      </template>
    </el-table-column>
    <el-table-column label="客户物料名称">
      <template scope="props">
        <p class="no-margin">{{props.row.CustomerProductName}}</p>
        <p class="no-margin" v-show="props.row.CustomerProductCode">物料编码：{{props.row.CustomerProductCode}}</p>
      </template>
    </el-table-column>
    <el-table-column label="品牌" prop="BrandName"></el-table-column>
    <el-table-column label="机型" prop="ModelName"></el-table-column>
    <el-table-column label="模块" prop="ModuleName"></el-table-column>
    <el-table-column label="租赁数量" prop="RentalQuantity"></el-table-column>
    <el-table-column label="保修期">
      <template scope="props">{{props.row.WarrantyMonths}}个月/{{props.row.WarrantyAmount}}元</template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="less" scoped>
.el-icon-information:hover {
  color: #20a0ff;
}
.sent-lot-title {
  color: #e88603;
  font-size: 13px;
  margin: 26px 0 0 58px;
  &:before {
    content: ' ';
    display: inline-block;
  }
}
.inner-list {
  margin: 0 30px;
  padding: 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-bottom: 1px solid #e6eaee;
  &:last-child {
    border-bottom: none;
  }
  .list-item {
    margin-right: 20px;
    min-width: 100px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    label {
      font-size: 12px;
      color: #86939e;
      line-height: 1.5;
    }
    p {
      color: #364152;
    }
  }
}
</style>

<style lang="less">
.el-tooltip__popper.is-dark.blue-tooltip {
  background: #20a0ff;
  .popper__arrow, .popper__arrow::after {
    border-top-color: #20a0ff;
  }
}
</style>



// WEBPACK FOOTER //
// LeaseDetailTableCancel.vue?fbc2ebf4